import { Component, OnInit } from "@angular/core";
import { ApiCalls } from "app/shared/api-calls";
import { ROUTES } from "./routes";

@Component({
  moduleId: module.id,
  selector: "sidebar-cmp",
  templateUrl: "sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  constructor(public apiCall: ApiCalls) {}
  public menuItems: any[];
  public loading: boolean = true;
  ngOnInit() {
    this.apiCall.getAllNodes().subscribe(
      (nodesData) => {
        let nodeChildren: any = [];
        const UKCities = {
          "United Kingdom": nodesData.body.data.response["United Kingdom"],
        };
        const PKCities = {
          Pakistan: nodesData.body.data.response["Pakistan"],
        };
        nodeChildren.push(UKCities);
        nodeChildren.push(PKCities);
        const nodes = nodeChildren.flatMap((countryNodes) => {
          return Object.keys(countryNodes).map((country) => {
            const countryData = countryNodes[country];
            return {
              title: country,
              icon: "nc-atom", // Replace with appropriate icon class
              children: countryData
                .sort((a: any, b: any) => {
                  if (a.device_name < b.device_name) {
                    return -1;
                  }
                  if (a.device_name > b.device_name) {
                    return 1;
                  }
                  return 0;
                })
                .map((route: any) => {
                  return {
                    title: route.device_name,
                    path: `nodes/${route.device_name}`, // Adjust the path as needed
                  };
                }),
            };
          });
        });

        nodes.forEach((item: any) => {
          item.expanded = false; // Initialize all menu items to collapsed state
        });

        const nodesPathIndex = ROUTES.findIndex(
          (route) => route.path === "/nodes"
        );

        if (nodesPathIndex !== -1) {
          ROUTES[nodesPathIndex].children = nodes;
        }

        // Update the menuItems array
        this.menuItems = ROUTES;
        this.loading = false;
      },
      (error: any) => {
        console.error(error);
        this.loading = false;
      }
    );
  }
}
